export default {
    name: 'FullScreen',

    methods: {
        /**
         * @override
         */
        setFullscreen(isFullScreen) {
            this.$store.dispatch('fullscreenStore/setFullScreen', isFullScreen);
        }
    },

    computed: {
        /**
         * @override
         */
        isFullScreen() {
            return this.$store.getters['fullscreenStore/fullscreen'];
        }
    }
};
